module.exports = __webpack_public_path__ + "4b2015d5b0f15c0ab7668871af1aeb93.png";